import {
    BookmarkCustom,
    BookmarkLink,
    BookmarkRawList,
    TVChannelDynamicList,
    TVChannelList,
    TVChannelSlideshowList,
    jObjectBase,
} from '../types';
import { AbortApiError, StandardApiError } from './network';

function ensureIsBookmarkLink(bookmark: BookmarkCustom | BookmarkLink): bookmark is BookmarkLink {
    return 'targetId' in bookmark && !!bookmark.targetId;
}

function ensureIsBookmarkCustom(bookmark: BookmarkCustom | BookmarkLink): bookmark is BookmarkCustom {
    const bookmarkCustom = bookmark as BookmarkCustom;
    return (
        bookmarkCustom.bookmarkLabel !== undefined ||
        bookmarkCustom.bookmarkMeta !== undefined ||
        bookmarkCustom.bookmarkUrl !== undefined
    );
}

function ensureIsBookmarkRawList(bookmark: jObjectBase | BookmarkRawList): bookmark is BookmarkRawList {
    const asBookmark = bookmark as BookmarkRawList;
    return asBookmark && typeof asBookmark.id === 'number' && typeof asBookmark.targetId === 'number';
}

type jObjectTypes = {
    bookmarkLink: BookmarkRawList;
};

const ensureFunctions = {
    bookmarkLink: ensureIsBookmarkRawList,
};

function ensureObjectIsType<T extends keyof jObjectTypes>(type: T, object: jObjectBase): object is jObjectTypes[T] {
    return object !== undefined && object !== null && ensureFunctions[type](object);
}

type ChannelsTypes = {
    DYNAMIC: TVChannelDynamicList;
    SLIDESHOW: TVChannelSlideshowList;
};

function ensureTVChannelIs<Type extends keyof ChannelsTypes>(
    channel: TVChannelList,
    type: Type,
): channel is ChannelsTypes[Type] {
    return 'tvChannelType' in channel && channel.tvChannelType === type;
}
// FIXME - err:unknown when typescript > 4.9.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ensureIsStandardApiError = (err: any): err is StandardApiError => {
    return (
        typeof err === 'object' &&
        err !== null &&
        'error' in err &&
        'errorMsg' in err &&
        'messages' in err &&
        typeof err.error === 'number' &&
        typeof err.errorMsg === 'string' &&
        Array.isArray(err.messages)
    );
};

// FIXME - err:unknown when typescript > 4.9.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ensureIsAbortApiError = (err: any): err is AbortApiError => {
    return (
        err !== null &&
        typeof err === 'object' &&
        'error' in err &&
        'aborted' in err &&
        err.error === -1 &&
        err.aborted === true
    );
};

export const jEnsure = {
    isBookmarkLink: ensureIsBookmarkLink,
    isBookmarkCustom: ensureIsBookmarkCustom,
    isBookmarkRawList: ensureIsBookmarkRawList,
    isTVChannelType: ensureTVChannelIs,
    objectIsType: ensureObjectIsType,
    isStandardApiError: ensureIsStandardApiError,
    isAbortApiError: ensureIsAbortApiError,
};
